module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('HeadersDetalhesResumo', {
    attrs: {
      "apelido": _vm.imovel.apelido,
      "proprietario": _vm.imovel.proprietario,
      "tipo": _vm.imovel.tipo
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "secondary white--text detalhes-header",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs2": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-left",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    staticClass: "ma-0 white--text",
    attrs: {
      "icon": "",
      "to": ({
        name: 'ImoveisDetalhesResumo',
        params: {
          id: _vm.$route.params.id
        }
      })
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-container', {
    staticClass: "py-2",
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "subtitulo"
  }, [_vm._v("Tarefas")])])], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.tarefas.length > 0) ? [_vm._l((_vm.tarefas), function(item, index) {
    return _c('v-card', {
      key: item.id,
      attrs: {
        "flat": ""
      }
    }, [_c('v-layout', {
      staticClass: "pt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm10": "",
        "offset-sm1": "",
        "md8": "",
        "offset-md2": ""
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "tarefas-meta-coluna",
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-icon', [_vm._v("event_available")]), _vm._v(" "), _c('TarefasSituacao', {
      key: item.data,
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    }, [_vm._v(_vm._s(item.data_formatada))])], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "tarefas-meta-coluna tarefas-meta-coluna-direita",
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('TarefasSituacao', {
      key: item.data,
      attrs: {
        "data": item.data,
        "realizada": item.realizada
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mt-2",
      attrs: {
        "xs12": ""
      }
    }, [_vm._v("\n                " + _vm._s(item.tipo) + "\n              ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('span', {
      staticClass: "grey--text"
    }, [_vm._v(_vm._s(_vm.taskUserName(item)))])])], 1)], 1), _vm._v(" "), (_vm.canCompleteTask(item)) ? _c('TarefasRealizar', {
      attrs: {
        "tarefaId": item.id,
        "imovelId": _vm.$route.params.id
      }
    }) : _vm._e(), _vm._v(" "), (_vm.canEditTask(item)) ? _c('v-btn', {
      staticClass: "text-xs-right primary--text",
      attrs: {
        "flat": "",
        "to": ({
          name: 'TarefasEditar',
          params: {
            id: _vm.$route.params.id,
            tarefa: item.id
          }
        })
      }
    }, [_vm._v("Editar")]) : _vm._e(), _vm._v(" "), (_vm.$hasGranularPermission('tarefas', 'delete')) ? _c('v-dialog', {
      attrs: {
        "lazy": "",
        "max-width": "520"
      },
      model: {
        value: (_vm.dialogApagar),
        callback: function($$v) {
          _vm.dialogApagar = $$v
        },
        expression: "dialogApagar"
      }
    }, [_c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "slot": "activator",
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.beforeApagar(item)
        }
      },
      slot: "activator"
    }, [_vm._v("Apagar")]), _vm._v(" "), _c('v-card', [_c('v-card-title', [_c('div', {
      staticClass: "headline"
    }, [_vm._v("Tem certeza que deseja apagar?")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Essa ação não poderá ser desfeita.")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      staticClass: "secondary--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.dialogApagar = false
        }
      }
    }, [_vm._v("Descartar")]), _vm._v(" "), _c('v-btn', {
      staticClass: "error--text",
      attrs: {
        "flat": ""
      },
      nativeOn: {
        "click": function($event) {
          _vm.onSubmitApagar()
        }
      }
    }, [_vm._v("Apagar")])], 1)], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-divider')], 1)
  }), _vm._v(" "), _c('IrParaOTopo')] : _c('p', {
    staticClass: "text-xs-center mt-5 subheading"
  }, [_vm._v("Nenhuma tarefa cadastrada.")]), _vm._v(" "), (_vm.canAddTask) ? _c('v-btn', {
    staticClass: "secondary",
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "bottom": "",
      "right": "",
      "to": ({
        name: 'TarefasAdicionar',
        params: {
          id: _vm.imovelId
        }
      })
    }
  }, [_c('v-icon', [_vm._v("add")])], 1) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-638681ff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tarefas/TarefasLista.vue
// module id = 1021
// module chunks = 1